/* eslint-disable no-empty */
/* eslint-disable react/no-array-index-key */
// RostroDetailChips.jsx
import React from "react"
import { Box, Chip, Typography } from "@material-ui/core"
import { CreditCard, CropFree, Lock } from "@material-ui/icons"

const parseTarjetas = raw => {
  if (!raw) return []
  if (Array.isArray(raw))
    return raw.filter(
      t => t && typeof t === "object" && t.tipo && t.codigo !== undefined
    )
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) return parsed
    } catch (_) {}
  }
  return []
}

const RostroDetailChips = ({ rostro }) => {
  if (!rostro) return null

  const tarjetas = parseTarjetas(rostro.tarjeta)
  const tags = tarjetas.filter(t => t.tipo === "tag")
  const qrs = tarjetas.filter(t => t.tipo === "qr")
  const pin = rostro.pin || ""

  if (!pin && tags.length === 0 && qrs.length === 0) return null

  return (
    <Box mt={0.5} display="flex" flexDirection="column" gap={0.5}>
      {/* ── PIN ── */}
      {pin && (
        <Box
          display="flex"
          alignItems="center"
          style={{ gap: 4 }}
          flexWrap="wrap"
        >
          <Lock style={{ fontSize: 14, color: "#388e3c" }} />
          <Typography
            variant="caption"
            style={{ fontWeight: 600, color: "#388e3c" }}
          >
            PIN
          </Typography>
          <Chip
            size="small"
            label={"•".repeat(Math.min(pin.length, 8))}
            style={{
              backgroundColor: "#e8f5e9",
              color: "#2e7d32",
              fontSize: "0.65rem",
              height: 18,
            }}
          />
        </Box>
      )}

      {/* ── TAGs ── */}
      {tags.length > 0 && (
        <Box
          display="flex"
          alignItems="flex-start"
          style={{ gap: 4 }}
          flexWrap="wrap"
        >
          <CreditCard
            style={{ fontSize: 14, color: "#1976d2", marginTop: 2 }}
          />
          <Typography
            variant="caption"
            style={{ fontWeight: 600, color: "#1976d2" }}
          >
            TAGs ({tags.length})
          </Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: 3 }}>
            {tags.map((t, i) => (
              <Chip
                key={i}
                size="small"
                label={t.label ? `${t.codigo} — ${t.label}` : t.codigo}
                style={{
                  backgroundColor: "#e3f2fd",
                  color: "#1565c0",
                  fontSize: "0.6rem",
                  height: 18,
                  maxWidth: 180,
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* ── QRs ── */}
      {qrs.length > 0 && (
        <Box
          display="flex"
          alignItems="flex-start"
          style={{ gap: 4 }}
          flexWrap="wrap"
        >
          <CropFree style={{ fontSize: 14, color: "#7b1fa2", marginTop: 2 }} />
          <Typography
            variant="caption"
            style={{ fontWeight: 600, color: "#7b1fa2" }}
          >
            QRs ({qrs.length})
          </Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: 3 }}>
            {qrs.map((t, i) => (
              <Chip
                key={i}
                size="small"
                label={t.label ? `${t.codigo} — ${t.label}` : t.codigo}
                style={{
                  backgroundColor: "#f3e5f5",
                  color: "#6a1b9a",
                  fontSize: "0.6rem",
                  height: 18,
                  maxWidth: 180,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default RostroDetailChips
